/* eslint-disable react/display-name */

import React from 'react'
import DataTable from '../../../components/table/tableOption'

const TableRecordLiquidation = ({ data, form }) => {
  const columns = [
    {
      dataField: 'idProveedor',
      text: form['antecliquidapp-grilla-idproveedor'],
      sort: true,
      headerAlign: 'center',
      align: 'center'
    },
    {
      dataField: 'nombreProveedor',
      text: form['antecliquidapp-grilla-proveedor'],
      sort: true,
      headerAlign: 'center',
      align: 'center'
    },
    {
      dataField: 'nroDocumento',
      text: form['antecliquidapp-grilla-iddocto'],
      sort: true,
      headerAlign: 'center',
      align: 'center'
    },
    {
      dataField: 'fechaDocumentoFormat',
      text: form['antecliquidapp-grilla-fechdocto'],
      sort: true,
      headerAlign: 'center',
      align: 'center'
    },
    {
      dataField: 'montoNeto',
      text: form['antecliquidapp-grilla-mtoneto'],
      sort: true,
      headerAlign: 'center',
      align: 'center'
    }
  ]

  const options = {
    columns,
    data,
    titleTableDoc: ''
  }

  return (
    <div>
      <DataTable {...options} />
    </div>
  )
}

export default TableRecordLiquidation
